/* eslint-disable */
import {
  createRouter,
  createWebHashHistory,
  createWebHistory,
} from "vue-router";
console.log(
  "Creating a router for ODP from pathname: ",
  document.location.pathname,
);

const dashboardOnlyMode = "abstract";
const appMode = "hash";

const dashboardOptions = [
  { path: "/", name: "Dashboard", component: "Dashboard", props: true },
];

const appOptions = [
  {
    path: "/dashboard",
    name: "Dashboard",
    component: "Dashboard",
    props: true,
  },
  { path: "/search", name: "Search", component: "Search", props: true },
  { path: "/", name: "redirectRoot", redirect: { name: "Dashboard" } },
  {
    path: "/:pathMatch(.*)*",
    name: "NotFound",
    component: "Dashboard",
    props: true,
  },
];

let routerOptions = undefined;
let history = undefined;

if (document.location.pathname.includes("/data")) {
  history = createWebHistory();
  routerOptions = appOptions;
} else {
  history = createWebHashHistory();
  routerOptions = dashboardOptions;
}

//history = createWebHistory()
//routerOptions = appOptions

const routes = routerOptions.map((route) => {
  let componentName = route.component;

  if (componentName === "Dashboard") {
    componentName = "Dashboard";
  }

  if (componentName === "Search") {
    componentName = "Search/Search";
  }

  return {
    ...route,
    component: () => import(`@/components/${componentName}`),
  };
});

/* eslint-disable no-new */
export default createRouter({
  history,
  routes,
});
